/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamComponentTypes200,
  GetApiV1ExamComponentTypes400,
  GetApiV1ExamComponentTypes401,
  GetApiV1ExamComponentTypes500,
  GetApiV1ExamComponentTypesQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamComponentTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamComponentTypes200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamComponentTypes200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamComponentTypes400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamComponentTypes400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamComponentTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamComponentTypes401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamComponentTypes500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamComponentTypes500>;

export const getApiV1ExamComponentTypesQueryResponseSchema = z.lazy(
  () => getApiV1ExamComponentTypes200Schema,
) as unknown as ToZod<GetApiV1ExamComponentTypesQueryResponse>;
